<script lang="ts">
    import {Route} from "svelte-router-spa";
    import MobileNavigation from "../Components/Navigation/MobileNavigation.svelte";
    import HeaderNavigation from "../Components/Navigation/HeaderNavigation.svelte";
    export let currentRoute;
</script>

<div class="flex flex-col h-full relative">
    <header class="flex-shrink-0 z-20">
        <HeaderNavigation {currentRoute} />
    </header>
    <main class="flex-1 z-10 overflow-auto">
        <Route {currentRoute} />
    </main>
    <footer class="flex-shrink-0 sm:hidden z-20">
        <MobileNavigation {currentRoute} />
    </footer>
</div>